import React, { useMemo, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getWhatsAppChatUrl } from "../../config/public-site";
import EcommerceHeader, { EcommerceFooter, WhatsAppFab } from "../../components/ecommerce/EcommerceHeader";
import CategoryScroller from "../../components/ecommerce/CategoryScroller";
import HeroCategoryCarousel from "../../components/ecommerce/HeroCategoryCarousel";
import ProductGrid from "../../components/ecommerce/ProductGrid";
// import { ECOMMERCE_CATEGORIES } from "../../data/ecommerce/categories";
// import { MOCK_PRODUCTS } from "../../data/ecommerce/products";
import { EC } from "../../utils/const/ecommerce-colors-const";
import { obtenerListaCategoriaProducto } from "../../api/api-categoria";
import { STRING_ID_ALL } from "../../utils/const/string-const";
import { obtenerListaProductosPublicos } from "../../api/api-producto";

export default function LandingPage() {
    const { t } = useTranslation();
    const history = useHistory();
    // const [activeCategory, setActiveCategory] = useState(STRING_ID_ALL);
    const [activeSection, setActiveSection] = useState("inicio");
    const whatsappUrl = getWhatsAppChatUrl();
    const currentYear = new Date().getFullYear();
    const [loadingPage, setLoadingPage] = useState(true);

    const [listaCategorias, setListaCategorias] = useState([]);
    const [categoriaSelected, setCategoriaSelected] = useState(null);

    const [listaProductosPublicos, setListaProductosPublicos] = useState([]);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const [
                responseCategoriasProductos,
                responseObtenerListaProductosPublicos
            ] = await Promise.all([
                obtenerListaCategoriaProducto(false, t),
                obtenerListaProductosPublicos({}, t)
            ]);
            // console.log("responseCategoriasProductos");
            // console.log(responseCategoriasProductos);
            if (responseCategoriasProductos.error === true) {
                throw new Error(responseCategoriasProductos.message);
            }
            if (responseCategoriasProductos.error === false) {
                setListaCategorias(responseCategoriasProductos.body);
            }
            // console.log("responseObtenerListaProductosPublicos");
            // console.log(responseObtenerListaProductosPublicos);
            if (responseObtenerListaProductosPublicos.error === true) {
                throw new Error(responseObtenerListaProductosPublicos.message);
            }
            if (responseObtenerListaProductosPublicos.error === false) {
                setListaProductosPublicos(
                    Array.isArray(responseObtenerListaProductosPublicos.body)
                        ? responseObtenerListaProductosPublicos.body
                        : []
                );
            }
        } catch (error) {
            console.log("error landing page");
            console.log(error);
        } finally {
            setLoadingPage(false);
        }

    };

    const filteredProducts = useMemo(() => {
        const products = Array.isArray(listaProductosPublicos) ? listaProductosPublicos : [];
        if (categoriaSelected === null) return products;
        if (categoriaSelected?.id === STRING_ID_ALL) return products;
        return products.filter((p) => p.idCategoriaProducto === categoriaSelected?.id);
    }, [categoriaSelected, listaProductosPublicos]);

    const scrollToSection = (id) => {
        setActiveSection(id);
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    const handleHeroCategorySelect = (category) => {
        // console.log("handleHeroCategorySelect");
        // console.log(category);
        setCategoriaSelected(category);
        scrollToSection("productos");
    };

    const render = () => {
        try {
            let categoriaSelectedLabel = t("ct_products_title");
            if (categoriaSelected) {
                categoriaSelectedLabel = t(`${categoriaSelected.descripcion}`);
            }
            return (
                <div className={EC.page.root}>
                    <div className="pointer-events-none fixed inset-0 overflow-hidden" aria-hidden>
                        <div className={`absolute -top-40 -right-32 h-96 w-96 rounded-full blur-3xl ${EC.page.blobPrimary}`} />
                        <div className={`absolute top-1/3 -left-24 h-80 w-80 rounded-full blur-3xl ${EC.page.blobPrice}`} />
                    </div>

                    <EcommerceHeader onNavClick={scrollToSection} activeSection={activeSection} />

                    <main>
                        <section id="inicio" className="relative px-4 sm:px-6 lg:px-8 pt-10 pb-14 md:pt-16 md:pb-20">
                            <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
                                <div className="text-center lg:text-left">
                                    <span className={`inline-flex items-center gap-2 mb-5 px-4 py-1.5 rounded-full text-sm font-semibold ${EC.hero.badge}`}>
                                        <span aria-hidden>✨</span>
                                        {t("ct_hero_badge")}
                                    </span>
                                    <h1 className="text-4xl sm:text-5xl lg:text-[3.25rem] font-extrabold text-slate-900 leading-[1.1] tracking-tight mb-6">
                                        {t("ct_hero_title")}
                                        <span className={`block mt-1 ${EC.hero.titleGradient}`}>
                                            {t("ct_hero_title_highlight")}
                                        </span>
                                    </h1>
                                    <p className="text-lg sm:text-xl text-slate-600 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
                                        {t("ct_hero_subtitle")}
                                    </p>
                                    <div className="flex flex-col sm:flex-row flex-wrap justify-center lg:justify-start gap-3">
                                        <button
                                            type="button"
                                            onClick={() => scrollToSection("productos")}
                                            className={EC.btn.primaryLg}
                                        >
                                            {t("ct_hero_cta_shop")}
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => scrollToSection("categorias")}
                                            className={EC.btn.secondary}
                                        >
                                            {t("ct_hero_cta_categories")}
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => history.push("/sign-up")}
                                            className={`inline-flex justify-center items-center gap-2 ${EC.btn.ghost}`}
                                        >
                                            {t("ct_hero_cta_sell")}
                                        </button>
                                    </div>
                                </div>

                                <div className="relative">
                                    <HeroCategoryCarousel
                                        categories={listaCategorias}
                                        onCategorySelect={handleHeroCategorySelect}
                                    />
                                    <div className={`absolute top-4 right-4 sm:-top-5 sm:-right-5 rounded-2xl bg-white border px-4 py-3 shadow-lg z-20 pointer-events-none ${EC.hero.statCard}`}>
                                        <p className="text-xs font-medium text-slate-500">{t("ct_hero_stat_label")}</p>
                                        <p className={`text-2xl font-extrabold ${EC.hero.statValue}`}>20+</p>
                                        <p className="text-sm font-semibold text-slate-800">{t("ct_hero_stat_categories")}</p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section id="categorias" className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 bg-white border-y border-slate-100">
                            <div className="max-w-7xl mx-auto">
                                <div className="text-center max-w-2xl mx-auto mb-8 md:mb-10">
                                    <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-3">
                                        {t("ct_categories_title")}
                                    </h2>
                                    <p className="text-lg text-slate-600">{t("ct_categories_subtitle")}</p>
                                </div>
                                <CategoryScroller
                                    categories={listaCategorias}
                                    activeCategory={categoriaSelected}
                                    onCategoryChange={setCategoriaSelected}
                                />
                            </div>
                        </section>

                        <section id="productos" className="py-12 md:py-16 px-4 sm:px-6 lg:px-8">
                            <div className="max-w-7xl mx-auto">
                                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 md:mb-10">
                                    <div>
                                        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-2">
                                            {categoriaSelected?.id === STRING_ID_ALL
                                                ? t("ct_products_title")
                                                : t("ct_products_filtered", { category: t(`${categoriaSelectedLabel}`) })}
                                        </h2>
                                        <p className="text-slate-600">{t("ct_products_subtitle")}</p>
                                    </div>
                                    <p className={EC.price.pill}>
                                        {t("ct_products_count", { count: filteredProducts?.length || 0 })}
                                    </p>
                                </div>
                                <ProductGrid
                                    products={filteredProducts}
                                    emptyMessage={t("ct_products_empty")}
                                />
                            </div>
                        </section>

                    </main>

                    <EcommerceFooter t={t} whatsappUrl={whatsappUrl} currentYear={currentYear} />
                    <WhatsAppFab whatsappUrl={whatsappUrl} ariaLabel={t("te_whatsapp_fab_aria")} />
                </div>
            );
        } catch (error) {
            console.log("error");
            console.log(error);
            return <div>Error: {error.message}</div>;
        }
    };

    return render();
}
